export const ExternalToolsWidgetKey = 'external-tools-widget:v1';
export const ExternalToolsWidgetKind = 'misc';
